import { Box, Text } from '@chakra-ui/react';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import React from 'react';
const Subscription = () => {
  const { t } = useTranslator();
  return (
    <>
      <Box
        as="hr"
        width="calc(100% + 32px)" // Adjust width to account for padding (16px on each side)
        marginX="-16px" // Negative margin to offset the padding
        background="#F9F9F9"
      />
      <Box padding="30px 16px 10px 16px">
        <Text
          color="#6B6B6B"
          fontFamily="Inter"
          fontWeight={400}
          fontSize="20px"
          lineHeight="28px"
        >
          {t('pages.featureOptimizedForDesktop') || "This Feature is optimized for our desktop site."}
        </Text>
      </Box>
    </>
  );
};

export default Subscription;
